import { I as Ne, j as t, T as X, b as Oe, B as je, V as we } from "./Spinner-dTAYYnIx.js";
import { C as $e } from "./Container-acMbkeg4.js";
import { S as Y } from "./Section-cF107_Su.js";
import { D as q } from "./domPurify-ugx5Lmst.js";
import { styled as h, css as s } from "styled-components";
import { f as he, e as o, t as pe } from "./index-QRkynDgW.js";
import { T as Z } from "./typography.styled-aDVGHct9.js";
import { d as oe, m as v, B as g, c as m, T as p, o as b, n as re, l as S, k as qe, p as R, a as G, r as z } from "./style-8UHgYe1v.js";
import { Q as He } from "./icon-quote-zcrX1RPR.js";
import { R as J, C as K, o as ie } from "./Row-qde4lVc-.js";
import { b as u } from "./backgroundSvg-a-Q-Xbdr.js";
import { V as Ve } from "./Video-LQCzApdB.js";
import { c as me } from "./Container.utils-sTvKNvoR.js";
import { A as C } from "./aspect-ratios-JlfRqse9.js";
import be, { useState as Ee, createElement as ye } from "react";
import { I as Re } from "./Image-8P7BYQsX.js";
import { Q as ke, a as Se } from "./QuickView-iAWr9na-.js";
import { u as ve } from "./useUuid-Vpcmoafn.js";
const Fe = h.figure`
  ${he};

  margin: 0;
  text-align: ${({ $align: e }) => e ? `${e}` : "left"};
`, Qe = h(Z)`
  margin-bottom: ${o.spacer2};
`, Ge = h(Z)`
  ${oe("color", "dominantAlpha80")}
`, Je = h(Ne)`
  display: inline-flex;
  margin-bottom: 20px;

  @media ${v(g.xl)} {
    margin-bottom: 28px;
  }
`, Ke = ({ $align: e, citeUrl: n, quote: a, author: r, role: i, theme: c }) => a ? /* @__PURE__ */ t.jsx(X, { theme: c, children: /* @__PURE__ */ t.jsx(Y, { "data-qa": "quote-component", children: /* @__PURE__ */ t.jsx($e, { children: /* @__PURE__ */ t.jsxs(Fe, { $align: e, $flexDirection: "column", $alignItems: e === "center" ? "center" : "flex-start", children: [
  /* @__PURE__ */ t.jsx(Je, { size: "lg", icon: He, color: m.redBrand }),
  /* @__PURE__ */ t.jsx(
    Z,
    {
      as: "blockquote",
      cite: n,
      $mb: { xs: "spacer4", xl: "spacer5" },
      $variant: p.headingLSerif,
      dangerouslySetInnerHTML: {
        __html: q(a, "inlineRichtext")
      }
    }
  ),
  r && /* @__PURE__ */ t.jsx(Qe, { $variant: p.labelMedium, as: "figcaption", children: r }),
  i && /* @__PURE__ */ t.jsx(Ge, { $variant: p.label, as: "cite", children: i })
] }) }) }) }) : null, Xe = h.div`
  ${b(p.body)}

  a {
    ${re.underline}
    color: inherit;

    &:hover {
      color: inherit;
    }
  }

  a:not(.xts-rich-text__button),
  b,
  strong {
    font-weight: ${S.medium};
  }


  .xts-rich-text {
    &__intro,
    &__body,
    &__body-m,
    &__body-drop-cap,
    &__footnote {
      a {
        ${re.underline}
        color: inherit;

        &:hover {
          color: inherit;
        }
      }


      strong,
      b {
        font-weight: ${S.semibold};
      }
    }

    &__footnote {
      ${b(p.bodyS)}
      margin: ${o.spacer4} 0 ${o.spacer7} 0;

      ${pe({
  dark: s`
          color: ${m.white};
        `,
  light: s`
          color: ${m.greyAlpha60};
        `
})}


        a:not(.xts-rich-text__button),
        b,
        strong {
          font-weight: ${S.medium};
        }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__intro {
      ${b(p.headingSSerif)}
      padding-top: ${o.spacer7};
      padding-bottom: ${o.spacer5};
      margin: 0;


        a:not(.xts-rich-text__button),
        b,
        strong {
          font-weight: ${S.semibold};
        }
    }

    &__h2 {
      ${b(p.headingLSerif)}
      padding: ${o.spacer5} 0;
      margin: 0;
    }

    &__h3 {
      ${b(p.headingMSans)}
      padding: ${o.spacer4} 0;
      margin: 0;
    }

    &__h4 {
      ${b(p.bodyMedium)}
      padding: ${o.spacer4} 0;
      margin: 0;
    }

    &__label {
      ${b(p.labelMedium)}
      margin: 0 0 ${o.spacer4} 0;
    }

    &__divider {
      margin: 0 0 ${o.spacer5} 0;
      padding: 0;

      ${pe({
  dark: s`
          border-bottom: 1px solid ${m.white};
        `,
  light: s`
          border-bottom: 1px solid ${m.greyAlpha10};
        `
})}

      &--dark {
        ${pe({
  dark: s`
            border-bottom: 1px solid ${m.white};
          `,
  light: s`
            border-bottom: 1px solid ${m.black};
          `
})}
      }

      @media ${v(g.xl)} {
        margin-bottom: ${o.spacer7};
      }
    }

    &__body {
      margin: 0 0 ${o.spacer7} 0;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__body-m {
      ${p.headingSSerif}
      margin: 0 0 ${o.spacer7} 0;

        a:not(.xts-rich-text__button),
        b,
        strong {
          font-weight: ${S.semibold};
        }

      &:last-child {
        margin-bottom: 0;
      }

      &:lang(zh),
      &:lang(zh_CN) {
        line-height: 1.6rem;

        @media ${v(g.xl)} {
          line-height: 1.75rem;
        }
      }
    }

    &__body-drop-cap {
      ${b(p.body)}
      margin: 0 0 ${o.spacer7} 0;

      &::first-letter {
        float: left;
        margin: 0.22em 0.15em 0.1em 0;
        font-family: ${qe.primary};
        font-size: 4.3rem;

        @media ${v(g.md)} {
          margin: 0.26em 0.1em 0.3em 0;
          font-size: 5.7rem;
        }
      }


        a:not(.xts-rich-text__button),
        b,
        strong {
          font-weight: ${S.medium};
        }

      &:last-child {
        margin-bottom: 0;
      }
    }

    /* Rich text editor requires a single class for each element/component */
    &__button {
      ${Oe}
    }

    &__icon-button {
      ${b(p.action)}
      ${re.underline}
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      margin: ${o.spacer5} 0;
      border: none;
      cursor: pointer;
      width: max-content;
      text-align: center;
      text-transform: uppercase;
      text-decoration: none;
      line-height: 1.5;
      white-space: nowrap;
      color: inherit;

      ${R(s`
        forced-color-adjust: preserve-parent-color;
      `)}

      &:hover,
      &:focus,
      &:active {
        text-decoration: underline;
        color: inherit;
      }

      &--right {
        flex-direction: row-reverse;

        .icon {
          margin-left: ${o.spacer2};
        }
      }

      .icon {
        display: block;
        margin-right: ${o.spacer2};
        background-repeat: no-repeat;
        padding: 0;
        width: 16px;
        height: 16px;

        &--large {
          width: 24px;
          height: 24px;
        }

        ${R(s`
          forced-color-adjust: preserve-parent-color;
        `)}
      }

      .icon-chevron {
        ${u("chevron")};
        transform: rotate(180deg);

        ${R(s`
          ${u("chevron", m.white)};
        `)}
      }

      .icon-arrow {
        ${u("arrow")};
        transform: rotate(180deg);

        ${R(s`
          ${u("arrow", m.white)};
        `)}
      }

      .icon-download {
        ${u("download")};

        ${R(s`
          ${u("download", m.white)};
        `)}
      }

      .icon-zoom {
        ${u("zoom")};

        ${R(s`
          ${u("zoom", m.white)};
        `)}
      }

      .icon-link {
        ${u("linkExternal")};

        ${R(s`
          ${u("linkExternal", m.white)};
        `)}
      }

      .icon-plus {
        ${u("plus")};

        ${R(s`
          ${u("plus", m.white)};
        `)}
      }
    }

    /* List styles */
    &__ordered-list {
      list-style-type: decimal;
    }

    &__unordered-list {
      padding-left: 23px;
      list-style-type: disc;

      li {
        padding-left: 7px;

        &::marker {
          font-size: 1.3rem;
        }
      }

      @media ${v(g.xl)} {
        padding-left: 29px;
      }
    }

    &__ordered-list,
    &__icon-list {
      padding-left: 18px;

      li {
        padding-left: ${o.spacer3};
      }

      @media ${v(g.xl)} {
        padding-left: ${o.spacer5};
      }
    }

    &__unordered-list,
    &__ordered-list,
    &__icon-list {
      ${b(p.body)}
      margin: ${o.spacer5} 0 ${o.spacer5} 0;

      li {
        margin-bottom: ${o.spacer5};

        &::marker {
          color: ${m.redBrand};
          font-weight: ${S.medium};
        }
      }
    }

    &__icon-list {
      list-style-type: none !important;

      li {
        position: relative;

        &::before {
          ${u("tick", m.redBrand)};
          position: absolute;
          top: 0;
          left: -20px;
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          content: '';

          ${R(s`
            forced-color-adjust: preserve-parent-color;
            ${u("tick", m.white)};
          `)}
        }
      }
    }

    &__center {
      text-align: center;
    }
  }
`, Ye = ({ html: e, theme: n, mdWidth: a = 8, onClick: r, position: i = "default" }) => {
  if (!e)
    return null;
  const c = Number(a), x = ($) => {
    r && r($);
  };
  return /* @__PURE__ */ t.jsx(X, { theme: n, children: /* @__PURE__ */ t.jsx(Y, { $spacing: "sm", $position: i, "data-qa": "rich-text-component", "data-position": i, children: /* @__PURE__ */ t.jsx($e, { $fluid: !0, children: /* @__PURE__ */ t.jsx(J, { children: /* @__PURE__ */ t.jsx(K, { $offset: { md: ie[c] }, $col: { xs: 12, md: c }, children: /* @__PURE__ */ t.jsx(
    Xe,
    {
      dangerouslySetInnerHTML: {
        __html: q(e, "mainRichtext")
      },
      onClick: x
    }
  ) }) }) }) }) });
}, Ce = h(Z)`
  padding-top: ${o.spacer4};
  ${oe("color", "dominantAlpha80")};

  ${({ $lgWidth: e }) => e && e === 12 && s`
      ${me}
    `}

  b,
  strong,
  u {
    ${oe("color", "dominant")};
  }
`, Ze = h(Y)`
  ${({ $lgWidth: e }) => e && e !== 12 && s`
      ${me}
    `}
`, Me = ({
  descriptionId: e,
  description: n,
  lgWidth: a = 12,
  theme: r,
  children: i,
  $position: c,
  componentName: x
}) => {
  const $ = Number(a);
  return /* @__PURE__ */ t.jsx(X, { theme: r, children: /* @__PURE__ */ t.jsxs(Ze, { $lgWidth: $, $fluid: !0, $position: c, "data-qa": x, children: [
    /* @__PURE__ */ t.jsx(J, { children: /* @__PURE__ */ t.jsx(
      K,
      {
        $offset: { lg: $ && $ !== 12 ? ie[$] : void 0 },
        $col: { lg: $ !== 12 ? $ : void 0 },
        children: i
      }
    ) }),
    n && /* @__PURE__ */ t.jsx(J, { children: /* @__PURE__ */ t.jsx(
      K,
      {
        $offset: { lg: $ && $ !== 12 ? ie[$] : void 0 },
        $col: { lg: $ },
        children: /* @__PURE__ */ t.jsx(
          Ce,
          {
            as: "p",
            $textAlign: "center",
            $lgWidth: $,
            $variant: p.bodyS,
            dangerouslySetInnerHTML: { __html: q(n, "inlineRichtext") },
            id: e,
            "data-qa": "description"
          }
        )
      }
    ) })
  ] }) });
}, Ue = ({
  description: e,
  lgWidth: n = 12,
  theme: a,
  imageUrl: r,
  $position: i,
  ...c
}) => {
  const x = r ? {
    xs: {
      src: r,
      maxWidth: 575,
      aspectRatio: C["16:9"]
    },
    sm: {
      src: r,
      maxWidth: 767,
      aspectRatio: C["16:9"]
    },
    md: {
      src: r,
      maxWidth: 1223,
      aspectRatio: C["16:9"]
    },
    lg: {
      src: r,
      maxWidth: Math.round(1823 * (12 / Number(n))),
      aspectRatio: C["16:9"]
    },
    xl: {
      src: r,
      maxWidth: Math.round(1920 * (12 / Number(n))),
      aspectRatio: C["16:9"]
    }
  } : void 0;
  return !x && !(c != null && c.videoUrl) ? null : /* @__PURE__ */ t.jsx(
    Me,
    {
      theme: a,
      description: e,
      lgWidth: n,
      $position: i,
      componentName: "video-component",
      children: /* @__PURE__ */ t.jsx(Ve, { images: x, ...c })
    }
  );
}, Ie = h(je).attrs({ variant: "no-style" })`
  width: 100%;
`, Pe = h(Re)`
  width: 100%;
`, et = ({
  theme: e,
  description: n,
  lgWidth: a = 12,
  image: r,
  cta: i,
  $position: c,
  $spacing: x,
  quickViewProps: $,
  quickViewZoomProps: U,
  enableGallery: I,
  onClick: L,
  currentSlide: se,
  galleryImages: w,
  t: k,
  ...ae
}) => {
  const H = ve(), [V, E] = Ee(!1), W = (A) => {
    const F = !V;
    L && L(A, i != null && i.href ? void 0 : F), !(i != null && i.href) && E(F);
  }, j = r == null ? void 0 : r.src, de = (r == null ? void 0 : r.alt) ?? "", P = (r == null ? void 0 : r.aspectRatio) || C["1:1"], D = Math.max(P, 1 / C["8:5"]), B = Math.max(P, C["8:5"]), ce = {
    xs: {
      src: j,
      maxWidth: 575,
      aspectRatio: D
    },
    sm: {
      src: j,
      maxWidth: 767,
      aspectRatio: D
    },
    md: {
      src: j,
      maxWidth: 1023,
      aspectRatio: B
    },
    lg: {
      src: j,
      maxWidth: 1223,
      aspectRatio: B
    },
    xl: {
      src: j,
      maxWidth: Math.round(1823 * (12 / Number(a))),
      aspectRatio: B
    },
    xxl: {
      src: j,
      maxWidth: Math.round(1920 * (12 / Number(a))),
      aspectRatio: B
    }
  }, f = ((n == null ? void 0 : n.length) ?? 0) > 0, ee = w && (w == null ? void 0 : w.length) > 0, T = !!(i != null && i.href), N = /* @__PURE__ */ t.jsx(
    Pe,
    {
      images: ce,
      alt: de,
      objectFit: "contain",
      ...f && { "aria-labelledby": `${H}` },
      ...ae
    }
  );
  return /* @__PURE__ */ t.jsxs(
    Me,
    {
      descriptionId: H,
      componentName: "single-image-component",
      theme: e,
      description: n,
      lgWidth: a,
      $spacing: x,
      $position: c,
      children: [
        T || ee && I ? /* @__PURE__ */ t.jsxs(Ie, { href: i == null ? void 0 : i.href, target: i == null ? void 0 : i.target, onClick: W, children: [
          /* @__PURE__ */ t.jsx(we, { children: T ? `${k == null ? void 0 : k.linkAccessibilityLabel} ${i == null ? void 0 : i.href}` : `${k == null ? void 0 : k.galleryAccessibilityLabel}` }),
          N
        ] }) : N,
        I && ee && $ && U && /* @__PURE__ */ t.jsx(ke, { ...$, isOpen: V, onClose: () => E(!1), currentSlide: se, children: w == null ? void 0 : w.map((A) => /* @__PURE__ */ ye(
          Se,
          {
            ...U,
            key: `${H}-${A.src}`,
            images: A,
            description: A.description
          }
        )) })
      ]
    }
  );
}, tt = {
  xs: o.spacer1,
  md: o.spacer4,
  xl: o.spacer5
}, nt = h.div`
  display: grid;
  grid-template:
    'leftImage'
    'leftDescription'
    'rightImage'
    'rightDescription';
  grid-template-areas:
    'leftImage'
    'leftDescription'
    'rightImage'
    'rightDescription';
  grid-template-rows: repeat(2, auto) minmax(${o.spacer4}, auto) repeat(2, auto);
  grid-template-columns: repeat(1, 1fr);
  row-gap: ${o.spacer4};

  ${G(
  g.md,
  s`
      grid-template-areas:
        'leftImage rightImage'
        'leftDescription rightDescription';
      grid-template-rows: repeat(2, auto);
      grid-template-columns: repeat(2, 1fr);
    `
)}

  ${Object.entries(tt).map(
  ([e, n]) => G(
    e,
    s`
        column-gap: ${n};
      `
  )
)}
`, rt = h(Y).attrs((e) => ({
  $fluid: !0,
  ...e
}))`
  ${me}
  ${({ $lgWidth: e }) => e === 12 && G(
  g.xl,
  s`
        padding-inline: 0;
      `
)}
`, xe = (e) => s`
  grid-area: ${({ $xPosition: n }) => `${n}${e}`};
`, ot = h(Re)`
  place-items: end stretch;
  height: 100%;
  white-space: break-spaces;

  ${({ $hasOverlay: e }) => e && s`
      picture {
        filter: brightness(0.6);
      }
    `};
`, it = h(Ce)`
  ${xe("Description")}

  align-self: start;
  padding: 0 0 ${o.spacer6} 0;

  ${G(
  g.sm,
  s`
      padding: 0;
    `
)}
`, st = h.div`
  ${xe("Image")}
`, at = h(je).attrs({ variant: "no-style" })`
  ${xe("Image")}

  display: block;
`, dt = h(Z)`
  padding: 0 ${o.spacer5};
  color: ${m.white};

  ${G(
  g.sm,
  s`
      padding: 0 ${o.spacer9};
    `
)};
`, M = (e, n) => Math.round(e * (12 / n) / 2), ge = (e, n) => {
  const a = n == null ? void 0 : n.src, r = (n == null ? void 0 : n.aspectRatio) ?? 1;
  return {
    xs: {
      src: a,
      aspectRatio: r,
      maxWidth: 575
    },
    sm: {
      src: a,
      aspectRatio: r,
      maxWidth: 767
    },
    md: {
      src: a,
      aspectRatio: r,
      maxWidth: M(1023, e)
    },
    lg: {
      src: a,
      aspectRatio: r,
      maxWidth: M(1223, e)
    },
    xl: {
      src: a,
      aspectRatio: r,
      maxWidth: M(1823, e)
    },
    xxl: {
      src: a,
      aspectRatio: r,
      maxWidth: M(1920, e)
    }
  };
}, _e = (e, n, a) => {
  const r = a == null ? void 0 : a.src, i = (a == null ? void 0 : a.aspectRatio) ?? 1;
  return {
    xs: {
      src: r,
      aspectRatio: i,
      maxWidth: 575
    },
    sm: {
      src: r,
      aspectRatio: i,
      maxWidth: 767
    },
    md: {
      src: r,
      aspectRatio: n.md.aspectRatio,
      maxWidth: M(1023, e)
    },
    lg: {
      src: r,
      aspectRatio: n.lg.aspectRatio,
      maxWidth: M(1223, e)
    },
    xl: {
      src: r,
      aspectRatio: n.xl.aspectRatio,
      maxWidth: M(1823, e)
    },
    xxl: {
      src: r,
      aspectRatio: n.xxl.aspectRatio,
      maxWidth: M(1920, e)
    }
  };
}, ct = ({
  theme: e,
  leftImage: n,
  leftImagePosition: a,
  leftCta: r,
  leftDescription: i,
  rightImage: c,
  rightImagePosition: x,
  rightCta: $,
  rightDescription: U,
  $position: I,
  imagesFit: L = "contain",
  lgWidth: se = 12,
  quickViewProps: w,
  quickViewZoomProps: k,
  enableLeftGallery: ae,
  enableRightGallery: H,
  leftOverlayDescription: V,
  rightOverlayDescription: E,
  galleryImages: W,
  currentSlide: j,
  t: de,
  ...P
}) => {
  const D = ve(), { galleryAccessibilityLabel: B, linkAccessibilityLabel: ce } = de, f = Number(se), ee = !!(V ?? E);
  let T = ge(f, n), N = ge(f, c);
  L === "contain" && (c != null && c.aspectRatio) && (n != null && n.aspectRatio) && (c.aspectRatio > n.aspectRatio ? T = _e(f, N, n) : c.aspectRatio < n.aspectRatio && (N = _e(f, T, c)));
  const A = (d, _, l) => {
    l != null && l.href || (fe(!0), De(_ === "left" ? j : (j || 0) + 1)), l != null && l.onClick && (l == null || l.onClick(d));
  }, F = (d, _, l, O, y, Q) => /* @__PURE__ */ t.jsx(
    ot,
    {
      images: d,
      alt: O,
      objectFit: L,
      objectPosition: `${l ?? "center"}`,
      ...Q && { "aria-labelledby": `${D}${_}` },
      $hasOverlay: ee,
      isBackgroundImage: !0,
      ...P,
      children: y && Ae(y)
    }
  ), We = (d, _, l) => /* @__PURE__ */ t.jsx(
    it,
    {
      id: `${D}${_}`,
      as: "p",
      $textAlign: "center",
      $variant: p.bodyS,
      dangerouslySetInnerHTML: { __html: q(d, "inlineRichtext") },
      $xPosition: _,
      "data-qa": "description",
      $mx: { xl: l === 12 ? "spacer2" : "spacer0", xxl: l === 12 ? "spacer4" : "spacer0" }
    }
  ), Ae = (d) => /* @__PURE__ */ t.jsx(dt, { as: "h2", $textAlign: "center", $variant: p.headingMSans, children: d }), ze = (d, _, l, O, y = "", Q, te, ne) => {
    const le = !!(d != null && d.href);
    return (d == null ? void 0 : d.href) ?? Q ? /* @__PURE__ */ t.jsxs(
      at,
      {
        href: d == null ? void 0 : d.href,
        target: d == null ? void 0 : d.target,
        $xPosition: l,
        onClick: (Te) => A(Te, l, d),
        theme: e,
        children: [
          /* @__PURE__ */ t.jsx(we, { children: le ? `${ce} ${d == null ? void 0 : d.href}` : B }),
          F(_, l, O, y, te, ne)
        ]
      }
    ) : /* @__PURE__ */ t.jsx(st, { $xPosition: l, children: F(_, l, O, y, te, ne) });
  }, ue = (d, _, l, O, y, Q, te, ne, le) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    ze(d, _, l, O, Q, te, ne, !!y),
    !!y && We(y, l, le)
  ] }), [Le, De] = be.useState(j), [Be, fe] = be.useState(!1);
  return /* @__PURE__ */ t.jsxs(X, { theme: e, children: [
    /* @__PURE__ */ t.jsx(rt, { $position: I, $lgWidth: f, "data-qa": "double-image-component", children: /* @__PURE__ */ t.jsx(J, { children: /* @__PURE__ */ t.jsx(
      K,
      {
        $offset: { lg: (12 - f) / 2 },
        $col: { lg: f !== 12 ? f : void 0 },
        children: /* @__PURE__ */ t.jsxs(nt, { $imagesFit: L, children: [
          ue(
            r,
            T,
            "left",
            a,
            i,
            n == null ? void 0 : n.alt,
            ae,
            V,
            f
          ),
          ue(
            $,
            N,
            "right",
            x,
            U,
            c == null ? void 0 : c.alt,
            H,
            E,
            f
          )
        ] })
      }
    ) }) }),
    W && (W == null ? void 0 : W.length) > 0 && /* @__PURE__ */ t.jsx(ke, { ...w, currentSlide: Le, isOpen: Be, onClose: () => fe(!1), children: W.map((d) => /* @__PURE__ */ ye(
      Se,
      {
        ...k,
        key: `${D}-${d.src}`,
        images: d,
        description: d.description
      }
    )) })
  ] });
}, lt = h.div.attrs({ $alignItems: "center", $justifyContent: "center" })`
  ${b(p.headingLSerif)}

  display: flex;
  margin: 0;

  ${b(p.headingLSerif)}

  a {
    ${re.underline}
    font-weight: ${S.semibold};
  }

  ${({ type: e }) => e === "general" && s`
      /* 1px represents the border width */
      padding-left: calc(${z(36)} + 1px);
    `}

  &::before {
    margin-right: ${o.spacer3};
    border-right: 1px solid;
    padding-right: ${o.spacer3};
    min-width: ${o.spacer3};
    ${oe("border-color", "dominantAlpha40")}

    ${he}

    ${({ type: e }) => e !== "general" && $t[e]}
    ${({ type: e }) => e === "bullet" && s`
        font-size: ${z(34)};
      `}
  }

  @media ${v(g.xl)} {
    ${({ type: e }) => e === "general" && s`
        /* padding should be 64px + 1px border width */
        padding-left: ${z(65)};
      `}
    &::before {
      margin-right: ${o.spacer5};
      padding-right: ${o.spacer5};
      ${({ type: e }) => e === "bullet" && s`
          font-size: ${z(45)};
        `}
    }
  }

  @media ${v(g.xxl)} {
    ${({ type: e }) => e === "general" && s`
        /* 72px + 1px border */
        padding-left: ${z(73)};
      `}
    &::before {
      ${({ type: e }) => e === "bullet" && s`
          font-size: ${z(68)};
        `}
    }
  }
`, pt = h.span.attrs({ $flexDirection: "column" })`
  ${he}
`, $t = {
  bullet: s`
    font-size: ${z(44)};
    content: '\\2022';
  `,
  number: s`
    content: counter(listicle-counter);
    counter-increment: listicle-counter;
  `
}, ht = ({
  headingLevel: e = "2",
  title: n,
  secondaryTitle: a,
  mdWidth: r = 8,
  type: i = "general",
  theme: c
}) => {
  const x = Number(r);
  return /* @__PURE__ */ t.jsx(X, { theme: c, children: /* @__PURE__ */ t.jsx(Y, { "data-qa": "listicle-id", children: /* @__PURE__ */ t.jsx($e, { $fluid: !0, children: /* @__PURE__ */ t.jsx(J, { children: /* @__PURE__ */ t.jsx(
    K,
    {
      $col: { md: x },
      $offset: { md: x && x !== 12 ? ie[x] : void 0 },
      children: /* @__PURE__ */ t.jsx(lt, { as: `h${e}`, type: i, children: /* @__PURE__ */ t.jsxs(pt, { children: [
        /* @__PURE__ */ t.jsx("span", { dangerouslySetInnerHTML: { __html: q(n, "inlineRichtext") } }),
        a && /* @__PURE__ */ t.jsx("span", { dangerouslySetInnerHTML: { __html: q(a, "listicleRichtext") } })
      ] }) })
    }
  ) }) }) }) });
}, zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blockquote: Ke,
  DoubleImage: ct,
  Image: et,
  Listicle: ht,
  Richtext: Ye,
  Video: Ue
}, Symbol.toStringTag, { value: "Module" }));
export {
  Ke as B,
  ct as D,
  et as I,
  ht as L,
  Ye as R,
  Ue as V,
  zt as i
};
